var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	55578: () => (loadSingletonVersionCheckFallback("default", "react", [,[1,18,0,0],[1,17,0,0],[1,16,8,0],1,1], () => (__webpack_require__.e(2500).then(() => (() => (__webpack_require__(29901))))))),
	55769: () => (loadSingletonVersionCheckFallback("default", "classnames", [1,2,2,6], () => (__webpack_require__.e(7608).then(() => (() => (__webpack_require__(87608))))))),
	14651: () => (loadSingletonVersionCheckFallback("default", "@editor-kit/utils", [7,4,112,0,,"alpha-v3-email",1], () => (__webpack_require__.e(4704).then(() => (() => (__webpack_require__(84704))))))),
	41197: () => (loadSingletonVersionCheckFallback("default", "react-dom", [0], () => (Promise.all([__webpack_require__.e(571), __webpack_require__.e(5208), __webpack_require__.e(2458)]).then(() => (() => (__webpack_require__(10571))))))),
	73089: () => (loadSingletonVersionCheckFallback("default", "react", [0], () => (__webpack_require__.e(2500).then(() => (() => (__webpack_require__(29901))))))),
	17077: () => (loadSingletonVersionCheckFallback("default", "@editor-kit/delta", [7,4,112,0,,"alpha-v3-email",1], () => (Promise.all([__webpack_require__.e(5718), __webpack_require__.e(4651)]).then(() => (() => (__webpack_require__(85718))))))),
	38750: () => (loadSingletonVersionCheckFallback("default", "mobx", [,[1,5,0,0],[1,4,0,0],1], () => (__webpack_require__.e(2771).then(() => (() => (__webpack_require__(72771))))))),
	92257: () => (loadSingletonVersionCheckFallback("default", "mobx", [,[1,4,15,4],[1,5,15,4],1], () => (__webpack_require__.e(2771).then(() => (() => (__webpack_require__(72771))))))),
	64320: () => (loadSingletonVersionCheckFallback("default", "react-dom", [4,16,13,1], () => (Promise.all([__webpack_require__.e(571), __webpack_require__.e(5208), __webpack_require__.e(2458)]).then(() => (() => (__webpack_require__(10571))))))),
	94267: () => (loadSingletonVersionCheckFallback("default", "react", [,[7,16,9,0,,"alpha",0],[1,16,8,0],1], () => (__webpack_require__.e(2500).then(() => (() => (__webpack_require__(29901))))))),
	77320: () => (loadSingletonVersionCheckFallback("default", "react", [1,16,8,0], () => (__webpack_require__.e(2500).then(() => (() => (__webpack_require__(29901))))))),
	75208: () => (loadSingletonVersionCheckFallback("default", "react", [4,17,0,2], () => (__webpack_require__.e(9901).then(() => (() => (__webpack_require__(29901))))))),
	24585: () => (loadSingletonVersionCheckFallback("default", "react", [0,16], () => (__webpack_require__.e(2500).then(() => (() => (__webpack_require__(29901))))))),
	22173: () => (loadSingletonVersionCheckFallback("default", "react-dom", [1,16,13,1], () => (Promise.all([__webpack_require__.e(571), __webpack_require__.e(5208), __webpack_require__.e(2458)]).then(() => (() => (__webpack_require__(10571))))))),
	13965: () => (loadSingletonVersionCheckFallback("default", "react", [0,15], () => (__webpack_require__.e(2500).then(() => (() => (__webpack_require__(29901))))))),
	75521: () => (loadSingletonVersionCheckFallback("default", "react-router", [4,5,3,4], () => (__webpack_require__.e(6172).then(() => (() => (__webpack_require__(96172))))))),
	21396: () => (loadSingletonFallback("default", "react", () => (__webpack_require__.e(9901).then(() => (() => (__webpack_require__(29901))))))),
	2323: () => (loadSingletonVersionCheckFallback("default", "i18next", [1,19,0,2], () => (__webpack_require__.e(7869).then(() => (() => (__webpack_require__(7869))))))),
	5038: () => (loadSingletonVersionCheckFallback("default", "react", [,[4,16,8,0],0,[0,16,8,0],2], () => (__webpack_require__.e(9901).then(() => (() => (__webpack_require__(29901))))))),
	47547: () => (loadSingletonVersionCheckFallback("default", "mobx-react", [1,6,1,4], () => (Promise.all([__webpack_require__.e(6699), __webpack_require__.e(7668)]).then(() => (() => (__webpack_require__(96699))))))),
	49636: () => (loadSingletonVersionCheckFallback("default", "react", [0,16,8,0], () => (__webpack_require__.e(9901).then(() => (() => (__webpack_require__(29901))))))),
	57531: () => (loadSingletonVersionCheckFallback("default", "query-string", [1,6,2,0], () => (__webpack_require__.e(1105).then(() => (() => (__webpack_require__(81105))))))),
	62811: () => (loadSingletonVersionCheckFallback("default", "react", [1,17], () => (__webpack_require__.e(9901).then(() => (() => (__webpack_require__(29901))))))),
	71379: () => (loadSingletonVersionCheckFallback("default", "moment", [1,2,22,2], () => (Promise.all([__webpack_require__.e(7200), __webpack_require__.e(7335)]).then(() => (() => (__webpack_require__(6901))))))),
	77000: () => (loadSingletonVersionCheckFallback("default", "@douyinfe/semi-icons", [4,2,38,2], () => (Promise.all([__webpack_require__.e(8000), __webpack_require__.e(7598)]).then(() => (() => (__webpack_require__(48000))))))),
	79636: () => (loadSingletonVersionCheckFallback("default", "react-query", [4,3,39,2], () => (Promise.all([__webpack_require__.e(1780), __webpack_require__.e(2173)]).then(() => (() => (__webpack_require__(11780))))))),
	80114: () => (loadSingletonVersionCheckFallback("default", "react-markdown", [1,6,0,2], () => (Promise.all([__webpack_require__.e(6340), __webpack_require__.e(4585)]).then(() => (() => (__webpack_require__(86340))))))),
	85130: () => (loadSingletonFallback("default", "axios", () => (__webpack_require__.e(1772).then(() => (() => (__webpack_require__(61772))))))),
	87118: () => (loadSingletonVersionCheckFallback("default", "mobx", [1,5,13,0], () => (__webpack_require__.e(2771).then(() => (() => (__webpack_require__(72771))))))),
	92171: () => (loadSingletonVersionCheckFallback("default", "axios", [1,1,4,0], () => (__webpack_require__.e(1772).then(() => (() => (__webpack_require__(61772))))))),
	44414: () => (loadSingletonFallback("default", "react-dom", () => (Promise.all([__webpack_require__.e(571), __webpack_require__.e(5208)]).then(() => (() => (__webpack_require__(10571))))))),
	93513: () => (loadSingletonVersionCheckFallback("default", "react-router-dom", [1,5,2,0], () => (Promise.all([__webpack_require__.e(6148), __webpack_require__.e(3965), __webpack_require__.e(5521), __webpack_require__.e(8846)]).then(() => (() => (__webpack_require__(97114))))))),
	3226: () => (loadSingletonVersionCheckFallback("default", "@editor-kit/core", [7,4,112,0,,"alpha-v3-email",1], () => (Promise.all([__webpack_require__.e(887), __webpack_require__.e(4651), __webpack_require__.e(9021)]).then(() => (() => (__webpack_require__(20887)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"1396": [
		21396
	],
	"1702": [
		3226
	],
	"2173": [
		22173
	],
	"3965": [
		13965
	],
	"4585": [
		24585
	],
	"4651": [
		14651
	],
	"5208": [
		75208
	],
	"5521": [
		75521
	],
	"5578": [
		55578
	],
	"5769": [
		55769
	],
	"5921": [
		2323,
		5038,
		47547,
		49636,
		57531,
		62811,
		71379,
		77000,
		79636,
		80114,
		85130,
		87118
	],
	"7077": [
		17077
	],
	"7668": [
		38750,
		92257,
		64320,
		94267,
		77320
	],
	"8821": [
		93513
	],
	"9021": [
		41197,
		73089
	],
	"9224": [
		44414
	],
	"9768": [
		92171
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}